import React from "react";
import { jsx as ___EmotionJSX } from "@emotion/react";
function Skeleton() {
  return ___EmotionJSX("div", {
    className: "h-32 w-full bg-gray-300 animate-pulse"
  });
}
export default Skeleton;